import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { BASE_URL } from '../../config/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class CategoryStockService {
  private DASHBOARD_URL = BASE_URL.URL;  

  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private route: Router) {
  }

  getChartData(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASHBOARD_URL}/charts/warehouses/4/stocks`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    })
      .pipe( 
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }else{
      this.spinnerService.hide();
      return throwError(()=> error);
    }
  }
}
 